<template>
  <div class="banner">
    <div class="container">
      <div class="banner-content">
        <!-- 左侧内容 -->
        <div class="left-content">
          <div class="year-tag">2026 生态互促·聚势共赢</div>
          <div class="main-title">从个体竞争<br>到<span class="highlight">生态共演</span></div>
          <div class="description">易隆创平台是“可自我进化”的数字业务基石。通过合伙人生态、服务生态、供应链生态及解决方案生态四大生态，将单兵作战转变为生态合力，彻底解决企业经营四大痛点。</div>
          <div class="btn-container">
            <div class="join-btn" @click="openDashboard">合伙人加盟<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="stats-container">
            <div class="stat-item">
              <span class="stat-number">{{ counts.companyTotalNumber }}+</span>
              <span class="stat-label">入驻合伙人</span>
            </div>
            <div class="stat-item">
              <span class="stat-number">1200+</span>
              <span class="stat-label">供应商生态</span>
            </div>
            <div class="stat-item">
              <span class="stat-number highlight">13980</span>
              <span class="stat-label">服务团队</span>
            </div>
            <div class="stat-item">
              <span class="stat-number">356+</span>
              <span class="stat-label">解决方案生态</span>
            </div>
          </div>
        </div>
        <!-- 右侧实时生态脉动 -->
        <div class="right-content">
          <div class="ecology-card">
            <div class="card-header">
              <div class="header-left">
                <div class="header-icon"></div>
                <div class="header-content">
                  <div class="header-title">实时生态脉动</div>
                  <div class="header-subtitle">LIVE PLATFORM FEED</div>
                </div>
              </div>
              <div class="header-right">
                <div class="refresh-btn">REC</div>
              </div>
            </div>
            <div class="card-content">
              <div class="feed-container">
                <div class="feed-list">
                  <div class="feed-item" v-for="(item, index) in feedItems" :key="index">
                    <div class="feed-tag" :class="item.tagClass">{{ item.tag }}</div>
                    <div class="feed-content">{{ item.content }}</div>
                    <div class="feed-time">{{ item.time }}</div>
                  </div>
                  <!-- 复制一份内容用于无缝滚动 -->
                  <div class="feed-item" v-for="(item, index) in feedItems" :key="'copy-' + index">
                    <div class="feed-tag" :class="item.tagClass">{{ item.tag }}</div>
                    <div class="feed-content">{{ item.content }}</div>
                    <div class="feed-time">{{ item.time }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="card-footer">
              <a href="#" class="detail-link">查看详情 <i class="arrow-icon">→</i></a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 云企业签约 -->
    <CloudEnterpriseSign ref="CloudEnterpriseSignRef"></CloudEnterpriseSign>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CompanyReportApi from '@/api/report/companyReportApi';
import CloudEnterpriseSign from '@/components/Popup/CloudEnterpriseSign.vue';

export default {
  components: { CloudEnterpriseSign },
  data() {
    return {
      counts: {
        companyTotalNumber: 0
      },
      feedItems: [
        {
          tag: '最新动态',
          tagClass: 'tag-primary',
          content: '今日第 12 个项目顺利交付，平均当前项目完成速度在 80%',
          time: '10分钟前'
        },
        {
          tag: '合作案例',
          tagClass: 'tag-secondary',
          content: '华南 5 家装饰材料供应商入驻，合伙人渠道需求大幅匹配，该项目已超期。',
          time: '30分钟前'
        },
        {
          tag: '最新合作匹配',
          tagClass: 'tag-tertiary',
          content: '广州某三甲医院医疗设备项目通过平台匹配成功对接 3 家方案商，预计完成度 90%。',
          time: '1小时前'
        },
        {
          tag: '最新动态',
          tagClass: 'tag-primary',
          content: '今日第 11 个项目顺利交付，平均当前项目完成速度在 78%',
          time: '2小时前'
        }
      ]
    }
  },
  computed: mapGetters(['isLoggIn', 'authStatus']),
  created() {
    this.getCounts();
  },
  methods: {
    ...mapActions(['setLoginPopup', 'setLoginCallback', 'setCloudRegisterPopup']),
    openDashboard() {
      if (!this.isLoggIn) this.setLoginPopup(true);
      else {
        // 判断是否需要前往认证
        if (['UNCOMPLETED', 'BACK'].includes(this.authStatus)) {
          this.$confirm('信息未完善，是否前往完善信息？', '提示', { type: 'warning' }).then(() => {
            this.$router.push('/personalInfo');
          });
        } else if (this.authStatus === 'COMPLETING') {
          this.$message.warning('认证信息审核中！');
        } else if (this.authStatus === 'UNSIGNED') {
          this.$refs.CloudEnterpriseSignRef.open();
        } else if (this.authStatus === 'COMPLETED') {
          this.$confirm('恭喜您完成加盟流程，是否即刻前往易隆创平台？', '提示', {
            confirmButtonText: '前往',
            type: 'success'
          }).then(() => {
            window.open(process.env.VUE_APP_URL + '#/dashboard', '_blank');
          });
        }
      }
    },
    getCounts() {
      CompanyReportApi.getReportByLogin({ year: null, month: null }).then(res => {
        if (res.code === '00000') {
          this.counts = res.model;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  padding: 64px 0;
  background-image: url('@/assets/img/home/Banner/background.png');
  background-size: cover;
  background-position: center;

  .container {
    max-width: @content-width;
    margin: 0 auto;
  }

  .banner-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 50px;
  }

  .left-content {
    flex: 1;

    .year-tag {
      display: inline-block;
      padding: 0 18px;
      background-color: rgba(255, 130, 1, 0.1);
      color: #ff6b00;
      font-size: 14px;
      font-weight: bold;
      border-radius: 16px;
      margin-bottom: 24px;
      line-height: 32px;
    }

    .main-title {
      font-family: @font-bold;
      font-size: 72px;
      margin-bottom: 24px;
      color: #333;

      .highlight {
        color: #ff6b00;
      }
    }

    .description {
      font-size: 20px;
      line-height: 1.625;
      color: #475569;
      margin-bottom: 20px;
      max-width: 576px;
    }

    .btn-container {
      margin-bottom: 48px;
      display: flex;

      .join-btn {
        padding: 16px 32px;
        display: flex;
        align-items: center;
        background-color: #F97316;
        background: #F97316;
        box-shadow: 0px 6px 12px 0px rgba(249,115,22,0.4);
        color: #fff;
        border-radius: 11px;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
        transition: background-color 0.3s ease;
        user-select: none;

        &:hover {
          background-color: #ea580c;
        }

        .el-icon-arrow-right {
          width: 18px;
          height: 18px;
          font-size: 14px;
          margin-left: 8px;
          background-color: rgb(245, 172, 134);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .stats-container {
      border-top: 1px solid #E5E7EB;
      padding-top: 24px;
      display: flex;
      gap: 75px;

      .stat-item {
        display: flex;
        flex-direction: column;

        .stat-number {
          font-size: 30px;
          font-family: @font-bold;
          color: #333;
          margin-bottom: 2px;
          &.highlight {
            color: #F97316;
          }
        }

        .stat-label {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }

  .right-content {
    width: 620px;
    height: 500px;

    .ecology-card {
      width: 100%;
      height: 100%;
      background-color: #1a1a2e;
      border-radius: 24px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      display: flex;
      flex-direction: column;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 32px;
        // border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        .header-left {
          display: flex;
          align-items: center;
          gap: 12px;

          .header-icon {
            width: 40px;
            height: 40px;
            background-color: #f97316;
            border-radius: 12px;
            background-image: url('@/assets/img/home/Banner/icon_windmill.png');
            background-size: 20px 20px;
            background-position: center;
            background-repeat: no-repeat;
          }

          .header-content {
            .header-title {
              font-size: 18px;
              font-weight: bold;
              color: #fff;
            }

            .header-subtitle {
              font-size: 12px;
              color: rgba(255, 255, 255, 0.6);
            }
          }
        }

        .header-right {
          .refresh-btn {
            padding: 0 8px 0 20px;
            background-color: rgba(239, 68, 68, 0.2);
            border-radius: 4px;
            font-size: 12px;
            color: rgba(239, 68, 68, 1);
            line-height: 24px;
            position: relative;
            &::before {
              content: '';
              position: absolute;
              top: 50%;
              left: 8px;
              transform: translateY(-50%);
              width: 6px;
              height: 6px;
              background-color: rgba(239, 68, 68, 1);
              border-radius: 50%;
            }
          }
        }
      }

      .card-content {
        flex: 1;
        padding: 0 32px 32px 32px;
        height: 0;

        .feed-container {
          height: 100%;
          overflow: hidden;
          position: relative;

          &:hover {
            .feed-list {
              animation-play-state: paused;
            }
          }

          .feed-list {
            position: relative;
            animation: scroll 12s linear infinite;

            &:hover {
              animation-play-state: paused;
            }
          }

          .feed-item {
            padding: 16px;
            border-radius: 6px;
            background-color: rgba(255, 255, 255, 0.05);
            margin-bottom: 12px;

            .feed-tag {
              display: inline-block;
              padding: 4px 8px;
              border-radius: 4px;
              font-size: 12px;
              font-weight: 500;
              margin-bottom: 8px;

              &.tag-primary {
                background-color: rgba(255, 107, 0, 0.2);
                color: #ff6b00;
              }

              &.tag-secondary {
                background-color: rgba(76, 175, 80, 0.2);
                color: #4caf50;
              }

              &.tag-tertiary {
                background-color: rgba(33, 150, 243, 0.2);
                color: #2196f3;
              }
            }

            .feed-content {
              font-size: 14px;
              color: rgba(255, 255, 255, 0.8);
              line-height: 1.4;
              margin-bottom: 8px;
            }

            .feed-time {
              font-size: 12px;
              color: rgba(255, 255, 255, 0.4);
            }
          }
        }

        @keyframes scroll {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(-50%);
          }
        }
      }

      .card-footer {
        padding: 20px 24px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);

        .detail-link {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #ff6b00;
          font-size: 14px;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }

          .arrow-icon {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
